import { render } from "./userprivilege.vue?vue&type=template&id=265266f1&scoped=true"
import script from "./userprivilege.vue?vue&type=script&lang=js"
export * from "./userprivilege.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./userprivilege.vue?vue&type=style&index=1&id=265266f1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265266f1"]])

export default __exports__